export enum CancellationPolicyEnum {
  HR_24_CANCELLATION_POLICY = "HR_24_CANCELLATION_POLICY",
  HR_48_CANCELLATION_POLICY = "HR_48_CANCELLATION_POLICY",
  NON_REFUNDABLE_POLICY = "NON_REFUNDABLE_POLICY",
  FREE_CANCELLATION_POLICY = "FREE_CANCELLATION_POLICY",
  GROUP_BOOKING_POLICY = "GROUP_BOOKING_POLICY",
  DAY_07_CANCELLATION_POLICY = "DAY_07_CANCELLATION_POLICY",
  DAY_14_CANCELLATION_POLICY = "DAY_14_CANCELLATION_POLICY",
}
